<template>
    <button class="button-signout btn btn-c--secondary fs-17 text-upper">
        <span>Wyloguj</span>
        <img 
            src="@/assets/images/icon-logout.png"
            alt=""
        >
    </button>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.button-signout {
    -ms-transform: translateY(-15px);

    > img {
        display: none;
    }
}
</style>
